<script lang="ts" setup></script>

<template>
  <span class="font-condensed text-sm text-green-100"><slot /></span>
</template>

<style scoped></style>
